import React from "react";

const Loader = () => {
  return (
    <div className="flex-center">
      <div className="text-center d-block">
        <div className="spinner-border" role="status">
          <span className="sr-only"> Loading... </span>
        </div>
      </div>
    </div>
  );
};

export default Loader;




// WEBPACK FOOTER //
// ./src/components/common/Loader.js